<div class="layout-wrapper">

  <div class="main-wrapper">
    <app-header class="mb-4"></app-header>

    <main>
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
